/**
 * Sends a POST request to the WordPress AJAX handler.
 *
 * This function is designed to facilitate communication with the WordPress backend via AJAX by sending a POST request.
 * It takes a `FormData` object as input, which should contain the data to be sent in the request. The function returns
 * a promise that resolves with the response from the server. This is particularly useful for handling asynchronous
 * operations such as submitting form data without reloading the page.
 *
 * @param {FormData} requestBody - The data to be sent in the AJAX request.
 * @returns {Promise<Response>} A promise that resolves with the server's response.
 */
const handleWPAjaxRequest = (requestBody: FormData): Promise<Response> => {

    return fetch("/wp-admin/admin-ajax.php", {
        method: "POST",
        body: requestBody
    });

}

export default handleWPAjaxRequest;